// Links that would leave the web view are handed to the shell, which opens them in
// the system browser. Without this they would replace the app's one and only web
// view, leaving the user stranded on a foreign page with no chrome to get back.

import { on } from 'shared/javascripts/util/events'
import { postNativeMessage } from './messages'

function leavesTheApp(anchor: HTMLAnchorElement): boolean {
  return (
    anchor.protocol !== location.protocol ||
    anchor.host !== location.host ||
    anchor.target === '_blank'
  )
}

export function interceptExternalLinks(): () => void {
  return on(document, 'click', (event: MouseEvent) => {
    const target = event.target
    const anchor = target instanceof Element ? target.closest('a') : null

    if (anchor instanceof HTMLAnchorElement && leavesTheApp(anchor)) {
      postNativeMessage({ command: 'openLink', url: anchor.href })
      event.preventDefault()
    }
  })
}
